import moment from 'moment';
import jMoment from 'moment-jalaali';

export default (date = undefined, _format = undefined) => {
        let _moment = null;
        let _error = false;

        if(app.lang.locale === "en")
        {
            moment.locale("en");
            if(_format !== undefined)
                _format = _format.split("j").join("");

            if (date && date !== "0000-00-00 00:00:00" && date !== "0000-00-00 00:00" && date !== "0000-00-00") {
                
                if (_format) {
                    _moment = moment(date, _format);
                } else {
                    _moment = moment(date);
                }
                
            } else {
                if (date === "0000-00-00 00:00:00" || date === "0000-00-00 00:00" || date === "0000-00-00") {
                    _error = true;
                }
                _moment = moment();
            }
    
            return {
                locale: (_locale)=>{
                    if (_error) return null;
                    return moment.locale(_locale);
                },
                jYear: ()=>{
                    if (_error) return null;
                    return _moment.year();
                },
                jMonth: ()=>{
                    if (_error) return null;
                    return _moment.month();
                },
                Year: ()=>{
                    if (_error) return null;
                    return _moment.year();
                },
                Month: ()=>{
                    if (_error) return null;
                    return _moment.month();
                },
                jDaysInMonth: (year, month) =>{
                    if (_error) return null;
                    return _moment.daysInMonth();
                    //return moment(`${year}-${month}-1`, "YYYY-M-D").daysInMonth();
                },
                weekday: () => {
                    if (_error) return null;
                    return _moment.day();
                },
                format: (__format) => {
                    if (_error) return null;

                    __format = __format.split("j").join("");

                    /*
                    if(__format === "jYYYY/jMM/jDD")
                        __format = "YYYY/MM/DD";
                        if(__format === "jYYYY-jMM-jDD")
                        __format = "YYYY-MM-DD";
                    if(__format === "jYYYY / jMM / jDD")
                        __format = "YYYY / MM / DD";
                    */
                        
                    return _moment.format(__format);
                },
                add: (len, type) => {
                    _moment = _moment.add(len, type)
                    return {
                        format: (___format) => {
                            if (_error) return null;
                            return _moment.format(___format);
                        },
                    };
                },
                startOf: (_type) => {
                    _moment = _moment.startOf(_type)
                    return {
                        format: (____format) => {
                            if (_error) return null;
                            return _moment.format(____format);
                        },
                    };
                },
            };
    
        }

        
        if(app.lang.locale === "fa")
        {
            let _jmoment = null;
            if (date && date !== "0000-00-00 00:00:00" && date !== "0000-00-00 00:00" && date !== "0000-00-00") {
                if (_format) {
                    _jmoment = jMoment(date, _format);
                } else {
                    _jmoment = jMoment(date);
                }
            } else {
                if (date === "0000-00-00 00:00:00" || date === "0000-00-00 00:00" || date === "0000-00-00") {
                    _error = true;
                }
                _jmoment = jMoment();
            }
    
            return {
                locale: (_locale)=>{
                    if (_error) return null;
                    return jMoment.locale(_locale);
                },
                jYear: ()=>{
                    if (_error) return null;
                    return _jmoment.jYear();
                },
                jMonth: ()=>{
                    if (_error) return null;
                    return _jmoment.jMonth();
                },
                jDaysInMonth: (year, month) =>{
                    if (_error) return null;
                    return jMoment.jDaysInMonth(year, month);
                    //return moment(`${year}-${month}-1`, "YYYY-M-D").daysInMonth();
                },
                weekday: () => {
                    if (_error) return null;
                    return _jmoment.weekday();
                },
                format: (__format) => {
                    if (_error) return null;
                    return _jmoment.format(__format);
                },
                add: (len, type) => {
                    _jmoment = _jmoment.add(len, type)
                    return {
                        format: (___format) => {
                            if (_error) return null;
                            return _jmoment.format(___format);
                        },
                    };
                },
                startOf: (_type) => {
                    _jmoment = _jmoment.startOf(_type)
                    return {
                        format: (____format) => {
                            if (_error) return null;
                            return _jmoment.format(____format);
                        },
                    };
                },
            };
                
        }
        
    };
